import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpers } from 'apps/webcomponents/src/assets/style-helpers.scss';
import { styles as flexHelpers } from 'apps/webcomponents/src/assets/flexbox-helpers.scss';

import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(commonStyles),
  unsafeCSS(componentStyles),
  unsafeCSS(styleHelpers),
  unsafeCSS(flexHelpers),
];
